import { extractNumber } from './extractNumber';
const roundToTwoDecimals = num => {
  return Number(num.toFixed(2));
};
const limitToRange = (value, min, max) => {
  return Math.min(Math.max(value, min), max);
};
export const normalizeValue = (raw, min, max) => {
  return roundToTwoDecimals(limitToRange(extractNumber(raw), min, max));
};